import { Component, OnInit } from '@angular/core';
import { DividasSerasa } from 'src/app/models/dividasPendentes/dividas-serasa';
import { UtilLarguraTela } from 'src/app/utils/configuracoes/util-largura-tela';
import { MensagemRetorno } from 'src/app/utils/mensagens.retorno';
import { BlocoDividasSerasaService } from '../../serasa/bloco-dividas-serasa.service';

@Component({
  selector: 'app-bloco-avisos-dividas-serasa',
  templateUrl: './bloco-avisos-dividas-serasa.component.html',
  styleUrls: ['./bloco-avisos-dividas-serasa.component.scss']
})
export class BlocoAvisosDividasSerasaComponent implements OnInit {
  public larguraEhSuperiorMin: boolean;
  public listaServicoFalha: Array<string>;
  public avisoDividasSerasa : DividasSerasa;
 

  constructor(private blocoDividasSerasaService: BlocoDividasSerasaService) {
    this.avisoDividasSerasa = new DividasSerasa();

   }

  ngOnInit(): void {
    this.listaServicoFalha = new Array();
    this.larguraEhSuperiorMin = UtilLarguraTela.checarLarguraTela();

    this.blocoDividasSerasaService.avisosDividas.subscribe(res => {
      this.avisoDividasSerasa = res;
      this.avisoDividasSerasa.falhaServico.message =  this.avisoDividasSerasa.resultadosPreNegativos.length > 0 ? "" : MensagemRetorno.mensagemRetornoStatus('200');
    })
  }
  
}
